import { useEffect } from "react";
import {
  createNotificationSocket,
  ExportDonePayload,
  ExportFailedPayload,
  PaymentCreatedPayload,
  PaymentReviewedPayload,
  WS_EVENTS,
} from "services/notificationSocket";

type ToastType = "success" | "error" | "info";

interface UseNotificationSocketOptions {
  accessToken?: string | null;
  onRealtimeNotification?: () => void;
  onToast?: (message: string, type?: ToastType) => void;
}

export function useNotificationSocket({
  accessToken,
  onRealtimeNotification,
  onToast,
}: UseNotificationSocketOptions) {
  useEffect(() => {
    if (!accessToken) return;

    const socket = createNotificationSocket(accessToken);

    socket.on("connect", () => {
      if (process.env.NODE_ENV === "development") {
        console.info("[notifications] connected", socket.id);
      }
    });

    socket.on("disconnect", (reason) => {
      if (process.env.NODE_ENV === "development") {
        console.info("[notifications] disconnected", reason);
      }
    });

    socket.on("connect_error", (error) => {
      if (process.env.NODE_ENV === "development") {
        console.error("[notifications] connect_error", error.message);
      }
    });

    socket.on(WS_EVENTS.PAYMENT_CREATED, (payload: PaymentCreatedPayload) => {
      onRealtimeNotification?.();
      onToast?.(`Phiếu thu ${payload.code} đang chờ phê duyệt`, "info");
    });

    socket.on(WS_EVENTS.PAYMENT_REVIEWED, (payload: PaymentReviewedPayload) => {
      onRealtimeNotification?.();
      onToast?.(
        payload.status === "approved"
          ? "Phiếu thu đã được phê duyệt"
          : "Phiếu thu đã bị từ chối",
        payload.status === "approved" ? "success" : "error",
      );
    });

    socket.on(WS_EVENTS.EXPORT_DONE, (_payload: ExportDonePayload) => {
      onRealtimeNotification?.();
      onToast?.("File xuất dữ liệu đã sẵn sàng tải xuống", "success");
    });

    socket.on(WS_EVENTS.EXPORT_FAILED, (payload: ExportFailedPayload) => {
      onRealtimeNotification?.();
      onToast?.(`Xuất file thất bại: ${payload.error}`, "error");
    });

    return () => {
      socket.disconnect();
    };
  }, [accessToken, onRealtimeNotification, onToast]);
}
